// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `external-video-manager simple-modal .simple-modal .modal-window img {
  width: 100%;
}
external-video-manager simple-modal .simple-modal .modal-window .error {
  color: var(--motes-light-red);
}
external-video-manager simple-modal .simple-modal .modal-window select.motes-select {
  width: 100%;
  border: 1px solid var(--motes-gray);
}
external-video-manager simple-modal .simple-modal .modal-window input.motes-input {
  border: 1px solid var(--motes-gray);
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/external-video-manager/external-video-manager.component.scss"],"names":[],"mappings":"AAIQ;EACI,WAAA;AAHZ;AAMQ;EACI,6BAAA;AAJZ;AAOQ;EACI,WAAA;EACA,mCAAA;AALZ;AAQQ;EACI,mCAAA;EACA,mBAAA;AANZ","sourcesContent":["external-video-manager {\n\n    simple-modal .simple-modal .modal-window {\n\n        img {\n            width: 100%;\n        }\n\n        .error {\n            color: var(--motes-light-red);\n        }\n\n        select.motes-select {\n            width: 100%;\n            border: 1px solid var(--motes-gray);\n        }\n\n        input.motes-input {\n            border: 1px solid var(--motes-gray);\n            margin-bottom: 20px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
